import { Injectable } from '@angular/core';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { IOnboardingReportParticipantDetails } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { FiItemsListOptionType } from '@fi-shared/fi-items-list/fi-items-list-option-type';
import { AppTextService } from '@fi-shared/app-text';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiStateService } from '@fi-app/shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IOnboardingUserCompletion } from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-completion';

@Injectable()
export class FiOnboardingReportActionsBuilderService {
    constructor(
        private appTextService: AppTextService,
        private fiUserDataService: FiUserDataService,
        private fiStateService: FiStateService,
    ) {}

    getParticipantDetailsActions(): IItemsListAction2<IOnboardingReportParticipantDetails>[] {
        return [
            {
                title: this.appTextService.get('onboarding.go_to_completion_mode'),
                condition: (item) => {
                    const onboardingToComplete = item.OnboardingsToComplete[0];
                    return onboardingToComplete.IsActive && !!this.getCurrentUserCompletion(item.UserCompletions);
                },
                onClick: (item) => {
                    this.fiStateService.go(FiStateNames.Onboarding.Completion, {
                        id: this.getCurrentUserCompletion(item.UserCompletions).OnboardingId,
                    });
                },
            },
        ];
    }

    private getCurrentUserCompletion(userCompletions: IOnboardingUserCompletion[]): IOnboardingUserCompletion {
        return userCompletions.find((uc) => uc.UserId === this.fiUserDataService.getUserId());
    }
}
